// extracted by mini-css-extract-plugin
module.exports = {"category-container":"page_category-container__vBvkq","category-title":"page_category-title__7r_ZR","seperator":"page_seperator__Rw95w"};